import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../utils';

interface Payload {
  format: string;
  objectId: string;
  name: string;
}

export const getPreSignedUrl = async (payload: Payload): Promise<string> => {
  const response = await axiosInstance.post('/api/s3/get-presigned-url', payload);
  return response.data;
};

export function useGetPreSignedUrl() {
  return useMutation(getPreSignedUrl, {
    onSuccess: (data) => data,
  });
}
